/**
 * Analytics exports
 *
 * - Product / app events: GA4 via GTM `dataLayer` (see `product-analytics.ts`)
 * - GTM helpers: typed ecommerce and page helpers (`gtm.ts`)
 */

export {
  identifyAmplitudeUser,
  resetAmplitudeUser,
  setAmplitudeConsent,
  trackAmplitudePageView,
} from "./amplitude";
export { captureSourceAttribution, getAttributionProperties } from "./attribution";
export {
  buildGtmConsentState,
  convertProductToGA4Item,
  type GA4Item,
  GTMEvents,
  setGtmConsent,
  trackAddToCart,
  trackBeginCheckout,
  trackEcommerceEvent,
  trackGTMEvent,
  trackProductView,
  trackPurchase,
  trackSearch,
  trackSignUp,
  useGTMTracking,
} from "./gtm";
export {
  AnalyticsEvents,
  getDeviceType,
  getEmailDomain,
  identifyUser,
  resetUser,
  setUserProperties,
  trackEvent,
  trackPageView,
  useTracking,
} from "./product-analytics";
